<template>
  <div class="page">
    <div class="section">
      <b-badge pill class="mybadge baseColor">Grammer#1 구분분석</b-badge>
      <b-badge pill class="mybadge pointColor"
        >Grammer#1 구분분석 단위분석2</b-badge
      >
    </div>

    <div class="section">
      <b-button variant="info" class="h-button">강좌</b-button>
    </div>

    <div class="section">
      <div style="display: inline-flex; align-items: center">
        <a link="#">검색</a>
        <span>
          <svg
            class="_ufjrdd"
            style="
              fill: #666666;
              height: 15px;
              width: 15px;
              display: flex;
              margin-left: 0.5rem;
              margin-right: 0.5rem;
            "
            viewBox="0 0 48 48"
            role="img"
            aria-labelledby="ChevronRight333636e4-7eba-4031-dd1b-60626a65317a ChevronRight333636e4-7eba-4031-dd1b-60626a65317aDesc"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="ChevronRight333636e4-7eba-4031-dd1b-60626a65317a">
              Chevron Right
            </title>
            <polygon
              transform="translate(23.999500, 24.000000) scale(-1, 1) translate(-23.999500, -24.000000)"
              points="16 24 30.585 40 31.999 38.586 18.828 24 31.999 9.415 30.585 8"
              role="presentation"
            />
          </svg>
        </span>
      </div>
      <div style="display: inline-flex; align-items: center">
        <a link="#">주제1</a>
        <span>
          <svg
            class="_ufjrdd"
            style="
              fill: #666666;
              height: 15px;
              width: 15px;
              display: flex;
              margin-left: 0.5rem;
              margin-right: 0.5rem;
            "
            viewBox="0 0 48 48"
            role="img"
            aria-labelledby="ChevronRight333636e4-7eba-4031-dd1b-60626a65317a ChevronRight333636e4-7eba-4031-dd1b-60626a65317aDesc"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="ChevronRight333636e4-7eba-4031-dd1b-60626a65317a">
              Chevron Right
            </title>
            <polygon
              transform="translate(23.999500, 24.000000) scale(-1, 1) translate(-23.999500, -24.000000)"
              points="16 24 30.585 40 31.999 38.586 18.828 24 31.999 9.415 30.585 8"
              role="presentation"
            />
          </svg>
        </span>
      </div>
      <div style="display: inline-flex; align-items: center">
        <a link="#">주제2</a>
        <span>
          <svg
            class="_ufjrdd"
            style="
              fill: #666666;
              height: 15px;
              width: 15px;
              display: flex;
              margin-left: 0.5rem;
              margin-right: 0.5rem;
            "
            viewBox="0 0 48 48"
            role="img"
            aria-labelledby="ChevronRight333636e4-7eba-4031-dd1b-60626a65317a ChevronRight333636e4-7eba-4031-dd1b-60626a65317aDesc"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="ChevronRight333636e4-7eba-4031-dd1b-60626a65317a">
              Chevron Right
            </title>
            <polygon
              transform="translate(23.999500, 24.000000) scale(-1, 1) translate(-23.999500, -24.000000)"
              points="16 24 30.585 40 31.999 38.586 18.828 24 31.999 9.415 30.585 8"
              role="presentation"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.mybadge {
  padding: 8px 10px 8px 10px;
  font-weight: 700;
  margin-right: 20px;
}
.baseColor {
  background-color: $gray400;
}

.h-button {
  min-width: 100px;
}

.page {
  padding: 50px;
}
.section {
  display: flex;
  flex-direction: row;
  //   min-height: 100px;
  width: 400px;
  justify-content: flex-start;
  margin-bottom: 50px;
}
</style>